import type React from "react";
import { toast } from "react-toastify";
import { useFreeMatchingApi } from "../../../hooks/use-free-matching-api";
import { useMatchingConditions } from "../../../hooks/use-matching-conditions-api";
import { MatchingPage as MatchingPagePresentation } from "./MatchingPage";

/**
 * フリーマッチングページ Container
 * フリーテキスト入力でマッチングを実行する
 * @return {JSX.Element} MatchingPage コンポーネント
 */
export const MatchingPage: React.FC = () => {
  const {
    executeFreetextMatching,
    updateResultStatus,
    loading,
    error,
    jobResult,
  } = useFreeMatchingApi();

  // マッチング条件の状態を取得
  const {
    settings: matchingConditionsList,
    loading: matchingConditionsLoading,
  } = useMatchingConditions();
  const hasActiveMatchingCondition =
    !matchingConditionsLoading && matchingConditionsList.some(s => s.isActive);

  const handleSearch = async (candidateInfo: string) => {
    if (!candidateInfo.trim()) return;

    try {
      const result = await executeFreetextMatching(candidateInfo);
      toast.success(
        `${result.resultsSaved}件のマッチング結果が見つかりました`,
        {
          position: "top-right",
          autoClose: 3000,
        },
      );
    } catch (_error) {
      toast.error("マッチング検索に失敗しました", {
        position: "top-right",
        autoClose: 5000,
      });
    }
  };

  const handleStatusUpdate = async (resultId: string, status: string) => {
    try {
      await updateResultStatus(resultId, status);
      toast.success("ステータスを更新しました", {
        position: "top-right",
        autoClose: 2000,
      });
    } catch (_error) {
      toast.error("ステータスの更新に失敗しました", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <MatchingPagePresentation
      jobResult={jobResult}
      isLoading={loading}
      error={error}
      hasActiveMatchingCondition={hasActiveMatchingCondition}
      onSearch={handleSearch}
      onStatusUpdate={handleStatusUpdate}
    />
  );
};

export default MatchingPage;
